module.exports = __webpack_public_path__ + "static/media/EdinburgIL_1-360w.6e54fff3.jpg";